module.exports = __webpack_public_path__ + "static/img/logo_100.b1ef94a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ds_img/logo_100.png
// module id = g13S
// module chunks = 18